import { svg, SVGTemplateResult } from "lit";

/** Default brand icon — globe/link (24×24, fill=currentColor) */
export const defaultBrandIcon: SVGTemplateResult = svg`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm-1 17.938A8.004 8.004 0 0 1 4 12c0-.34.028-.674.075-1.003L8 14.938V16a2 2 0 0 0 2 2v1.938Zm6.906-2.462A1.993 1.993 0 0 0 16 16h-1v-3a1 1 0 0 0-1-1H8v-2h2a1 1 0 0 0 1-1V7h2a2 2 0 0 0 2-2v-.41A7.997 7.997 0 0 1 20 12a7.97 7.97 0 0 1-2.094 5.476Z"/>
  </svg>`;
